import { useContext } from "react";
import { ContextMenuContext } from "../providers";

export function useContextMenu() {
  return useContext(ContextMenuContext);
}
